import React from 'react'

const Title = ({ title }) =>
  <h1 className="title">
    {title}
  </h1>

export default Title



// WEBPACK FOOTER //
// ./src/components/Title.js